import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a2d7f38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "data" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "曝光数据")
], -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "曝光率", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "访客数", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "电联数", -1))
const _hoisted_10 = { class: "data" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "供求数据")
], -1))
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "num" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的供应", -1))
const _hoisted_15 = { class: "num" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的求购", -1))
const _hoisted_17 = { class: "num" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的报价", -1))
const _hoisted_19 = { class: "share" }
const _hoisted_20 = { class: "editshop" }
const _hoisted_21 = { class: "prospect" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "潜在客户/电联客户数", -1))
const _hoisted_23 = { class: "listItem" }
const _hoisted_24 = { class: "info" }
const _hoisted_25 = { class: "name" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "查看了您的店铺", -1))
const _hoisted_27 = { class: "time" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("拨打电话")
const _hoisted_29 = { class: "actions" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("我知道了")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyHeader = _resolveComponent("MyHeader")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MyHeader, {
        detail: _ctx.detail,
        type: "Shop"
      }, null, 8, ["detail"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_ctx.userInfo.totalExposure || '-'), 1),
          _hoisted_7
        ]),
        _createElementVNode("a", {
          class: "item",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showProspect && _ctx.showProspect(...args)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.userInfo.totalFlows), 1),
          _hoisted_8
        ]),
        _createElementVNode("a", {
          class: "item",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showProspect && _ctx.showProspect(...args)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.userInfo.totalMobileContant), 1),
          _hoisted_9
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("a", {
          class: "item",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push({name:"MySupplyList"})))
        }, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.userInfo.supply), 1),
          _hoisted_14
        ]),
        _createElementVNode("a", {
          class: "item",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.push({name:"MyWantToBuyList"})))
        }, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.userInfo.purchase), 1),
          _hoisted_16
        ]),
        _createElementVNode("a", {
          class: "item",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.router.push({name:"MyOfferPriceList"})))
        }, [
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.userInfo.quotation), 1),
          _hoisted_18
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_VanImage, {
        src: require('@/assets/img/sharefriend.png'),
        width: "55",
        height: "55",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sharefriend()))
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_VanImage, {
        src: require('@/assets/img/editshop.png'),
        width: "55",
        height: "55",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toedit()))
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_VanPopup, {
      show: _ctx.isShowPotential,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isShowPotential) = $event)),
      style: {"width":"80vw","max-height":"60vh","border-radius":"12px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_component_VanList, {
            class: "list",
            listLoading: _ctx.loading,
            "onUpdate:listLoading": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.loading) = $event)),
            onLoad: _ctx.loadMore,
            "immediate-check": false,
            finished: _ctx.finished,
            "finished-text": "没有更多了"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prospects, (item) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createVNode(_component_VanImage, {
                    src: item.visitorAvatarUrl,
                    width: "56px",
                    height: "56px",
                    round: ""
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(item.visitorNickName), 1),
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.moment(item.createTime).fromNow()), 1)
                  ]),
                  _createVNode(_component_VanButton, {
                    type: "success",
                    size: "small",
                    color: "#F83B2D",
                    round: "",
                    onClick: ($event: any) => (_ctx.call(item.visitorId))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_28
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              }), 256))
            ]),
            _: 1
          }, 8, ["listLoading", "onLoad", "finished"]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_VanButton, {
              type: "success",
              size: "small",
              color: "#FFCC32",
              round: "",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowPotential = false))
            }, {
              default: _withCtx(() => [
                _hoisted_30
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_VanPopup, {
      class: "openDialog",
      show: _ctx.isShowOpen,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isShowOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VanImage, {
          src: "https://mdd-static.oss-cn-hangzhou.aliyuncs.com/wechat/h5/share.png",
          width: "100%"
        })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}